const CUSTOM_BUTTON_PRESETS = [
  {
    id: "button-cta-1",
    name: "Button CTA #1",
    values: {
      enableIcon: true,
      icon: "arrow",
      borderRadius: "5",
      fontSize: "24",
      paddingY: "28",
    },
  },
  {
    id: "button-cta-2",
    name: "Button CTA #2",
    values: {
      bgColor: "#08b335",
      enableBorder: true,
      borderColor: "#0a7915",
      borderRadius: "5",
      fontSize: "26",
      enableIcon: true,
      icon: "arrow",
      width: "420",
      paddingY: "12",
      paddingX: "12",
    },
  },
  {
    id: "button-cta-3",
    name: "Button CTA #3",
    values: {
      bgColor: "#40b426",
      fontSize: "16",
      borderRadius: "5",
      paddingY: "13",
      width: "200",
    },
  },
  {
    id: "button-cta-4",
    name: "Button CTA #4",
    values: {
      enableBorder: true,
      borderWidth: "1",
      paddingY: "16",
      paddingX: "20",
      enable3d: true,
      shadowX: "0",
      shadowY: "4",
      shadowBlur: "8",
      shadowColor: "#00000026",
    },
  },
  {
    id: "button-with-ad",
    name: "Button CTA (With Ad)",
    values: {
      bgColor: "#1f9d06",
      borderRadius: "12",
      enableIcon: true,
      icon: "arrow",
      enableAd: true,
      paddingY: "18",
      paddingX: "24",
      enable3d: true,
      shadowX: "0",
      shadowY: "5",
      shadowColor: "#125c05",
    },
  },
  {
    id: "animated-button",
    name: "Animated Button",
    values: {
      bgColor: "#004b75",
      enableHover: true,
      hoverColor: "#003452",
      borderRadius: "5",
      fontSize: "30",
      enablePulse: true,
      paddingY: "40",
      paddingX: "30",
      width: "540",
    },
  },
  {
    id: "call-cta-phone",
    name: "Call CTA #1",
    values: {
      enableIcon: true,
      icon: "phone",
      borderRadius: "5",
      fontSize: "24",
      paddingY: "28",
    },
  },
  {
    id: "call-cta-button-number",
    name: "Call CTA #2",
    values: {
      bgColor: "#1cb91f",
      enableBorder: true,
      borderColor: "#1da220",
      borderRadius: "8",
      enableIcon: true,
      icon: "phone",
      iconGap: "16",
      enablePulse: true,
      enableSecondLine: true,
      fontSize: "30",
      secondaryFontSize: "16",
      paddingY: "18",
      paddingX: "24",
      width: "360",
      enable3d: true,
      shadowX: "0",
      shadowBlur: "12",
      shadowColor: "#00000026",
    },
  },
  {
    id: "livechat-cta-1",
    name: "Livechat CTA #1",
    values: {
      bgColor: "#007bee",
      borderRadius: "320",
      fontSize: "16",
      paddingY: "12",
      width: "260",
    },
  },
  {
    id: "livechat-cta-2",
    name: "Livechat CTA #2",
    values: {
      borderRadius: "320",
      fontSize: "18",
      paddingY: "12",
      width: "320",
      enableIcon: true,
      icon: "phone",
      enableSecondLine: true,
      secondaryText: "1-800-000-0000",
      secondaryFontSize: "16",
    },
  },
];

export { CUSTOM_BUTTON_PRESETS };
